<template>
    <div class="tags-filter">
        <div class="tags-filter__list">
            <tag
                class="tags-filter__item"
                v-for="(item, index) in data"
                ref="tag"
                :key="item.id"
                :id="item.id"
                theme="light-blue"
                size="m"
                :name="item.text"
                @change="onChange"
                :disabled="item.disabled"
                :selected="item.selected"
            />
        </div>

        <z-link
            tag="button"
            icon-position="right"
            icon="tools/close-small"
            @click="clear"
            size="s"
            :underlined="false"
            v-if="selected.length"
            class="tags-filter__clear"
            theme="dark"
        >
            <span v-html="clearText"></span>
        </z-link>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Tag from './Tag.vue'

export default {
    name: 'tags-filter',
    components: {
        Tag
    },
    props: {
        title: String,
        name: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            default: () => []
        },
        clearText: {
            type: String,
            default: localize({
                ru: 'Сбросить теги',
                en: 'Reset tags',
                cn: 'Reset tags'
            })
        }
    },
    data () {
        return {
            selected: []
        }
    },
    methods: {
        onChange (data) {
            const index = this.selected.indexOf(data.id)
            if (!data.value && index !== -1) this.selected.splice(index, 1)
            if (data.value && index === -1) this.selected.push(data.id)

            // подумать над выносом в отедльную функицю с throttle
            this.$emit('change', {
                name: this.name,
                value: this.selected
            })
        },
        clear () {
            if (this.$refs.tag) {
                this.$refs.tag.forEach(item => item.clear())
            }
            this.selected = []
            this.$emit('clear', {
                name: this.name,
                value: this.selected
            })
        }
    },
    beforeMount () {
        this.selected = this.data.filter(item => item.selected).map(item => item.id)
    }
}
</script>

<style lang="scss">
.tags-filter {
    &__list {
        margin-top: -var(--spacer-3xs);
        margin-left: -var(--spacer-3xs)/2;
        margin-right: -var(--spacer-3xs)/2;
    }

    &__item {
        margin-top: var(--spacer-3xs);
        margin-left: var(--spacer-3xs)/2;
        margin-right: var(--spacer-3xs)/2;

        &.tag--active {
            padding: 7px 16px;
        }
    }

    &__clear {
        display: block !important;
        width: max-content;
        @include margin-level(top, XS);
        margin-left: var(--spacer-2xs);
    }
}
</style>
